import React from 'react';

import CMSContent from '../CMSContent/index.jsx';


class ArticleListItem extends React.Component {
  render() {
    return (
      <div className="cs-article-list__item">
        {this.props.children}
      </div>
    );
  }
}


class ArticleListEmpty extends React.Component {
  render() {
    return (
      <CMSContent>
        <h3 className="text-center has-grey-500-color">No Results.</h3>
      </CMSContent>
    );
  }
}


class ArticleList extends React.Component {
  render() {
    return (
      <div className="cs-article-list">
        {this.props.children}
      </div>
    );
  }
}


// for convenience, export the Item as a property of the parent component
ArticleList.Item = ArticleListItem;
ArticleList.Empty = ArticleListEmpty;


export default ArticleList;

